import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as moment from 'moment-timezone';
/**
* A moment timezone pipe to support parsing based on time zone abbreviations
* covers all cases of offset variation due to daylight saving.
*
* Same API as DatePipe with additional timezone abbreviation support
* Official date pipe dropped support for abbreviations names from
Angular V5
*/
@Pipe({
  name: 'momentDate'
})
export class MomentDatePipe extends DatePipe implements PipeTransform {
  transform(
    value: string | Date,
    format: Format,
    timezone: string = 'Europe/Athens'
  ): string {

    const timezoneOffset = moment(value).tz(timezone).format('DD/MM/YYYY');
    return super.transform(value, format, timezoneOffset);
  }
}

//'dd-MM-yyyy HH:mm'
export interface IFullFormat {
  fullFormat: string;
}

//'dd-MM-yyyy'
export interface ILessFormat {
  lessFormat: string;
}

let full: IFullFormat = {
  fullFormat: 'dd-MM-yyyy HH:mm'
}
let less: ILessFormat = {
  lessFormat: 'dd-MM-yyyy'
}

export type Format = typeof full.fullFormat | typeof less.lessFormat;
